<template>
  <span>
    <site-link
      v-if="isShowingUpgrade"
      :to="{ name: 'plans' }"
      class="margin-right-md"
      @click.native="$posthog.capture('usage:plans_link_click')"
    >
      Upgrade
    </site-link>
    <site-link
      v-if="type === 'kit'"
      :to="$docs('/web/setup/use-kit', { hash: '#tune-your-kits' })"
      @click.native="$posthog.capture('usage:tune_your_kits_link_click')"
    >
      How to Tune Your Kits
    </site-link>
    <site-link
      v-else-if="type === 'npm'"
      :to="$docs('/web/dig-deeper/continuous-integration')"
      @click.native="$posthog.capture('usage:tune_your_ci_link_click')"
    >
      How to Tune Your CI
    </site-link>
  </span>
</template>

<script>
  import { EventTrackingMixin } from 'app/mixins'

  export default {
    name: 'UsageActions',

    mixins: [EventTrackingMixin],

    props: {
      isShowingUpgrade: {
        type: Boolean,
        default: true
      },
      type: {
        type: String,
        required: true
      }
    }
  }
</script>
